const PageTitle = ({children}) => {
    return (
        <h1 className={"text-center text-3xl font-bold text-cyan-900"}>
            {children}
        </h1>
    )
}

export default PageTitle